.container {
	width: 100%;
	padding: 0 15px;
	font-family: "Helvetica Neue", sans-serif;
	color: #222;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;

	h1 {
		font-size: 1.2rem;
		font-weight: 500;
		margin: 0;
	}

	button {
		background: none;
		color: #81ba43;
		border: none;
		font-size: 0.9rem;
		cursor: pointer;
		padding: 0.3rem 0.8rem;
		border-radius: 4px;
		border: 1px solid #7fb02f;

		&:hover {
			background-color: rgba(129, 186, 67, 0.1);
		}
	}
}

.form {
	display: flex;
	gap: 0.5rem;
	margin-bottom: 1.5rem;

	input[type="date"] {
		padding: 0.4rem 0.6rem;
		font-size: 0.9rem;
		border: 1px solid #ccc;
		border-radius: 4px;
		background: transparent;
	}

	button {
		background-color: #81ba43;
		color: white;
		border: none;
		padding: 0.4rem 1rem;
		border-radius: 4px;
		cursor: pointer;
		font-size: 0.9rem;

		&:hover {
			background-color: #6ea939;
		}
	}
}

.table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	font-size: 0.9rem;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	border: 1px solid #e0e0e0;

	thead {
		background-color: #fafbf8;
	}

	th {
		padding: 0.8rem 1rem;
		text-align: left;
		font-weight: 400;
	}

	td {
		padding: 0.8rem 1rem;
		text-align: left;
		font-weight: 400;
	}

	th {
		font-weight: 500;
		color: #666;
	}

	tbody tr {
		border-top: 1px solid #eee;

		&:last-child td {
			border-bottom: none;
		}
	}
}

.badge {
	display: inline-block;
	padding: 0.3rem 0.6rem;
	font-size: 0.75rem;
	border-radius: 20px;
	cursor: pointer;
	user-select: none;
	transition: background-color 0.2s ease;
}

.active {
	background-color: #e0f3d1;
	color: #4e8d10;
	pointer-events: none;
}

.inactive {
	background-color: #f0f0f0;
	color: #666;

	&:hover {
		background-color: #e6e6e6;
	}
}

.editInput {
	padding: 0.3rem 0.5rem;
	font-size: 0.85rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #fafafa;
	color: #333;
}

.inlineButton {
	background-color: transparent;
	border: 1px solid #ccc;
	color: #555;
	padding: 0.3rem 0.6rem;
	border-radius: 4px;
	font-size: 0.8rem;
	cursor: pointer;
	margin-left: 0.3rem;
	transition: all 0.2s ease;

	&:hover {
		background-color: #f2f2f2;
	}

	&.remove {
		border: 1px solid #f44336;
		color: #f44336;

		&:hover {
			background-color: #f44336;
			color: #fff;
		}
	}
}

.save {
	background-color: #81ba43;
	color: #fff;
	border: none;

	&:hover {
		background-color: #6ea939;
	}
}

.cancel {
	border-color: #ccc;
	color: #666;

	&:hover {
		background-color: #eee;
	}
}

.actions {
	text-align: right;
	display: flex;
	gap: 0.5rem;
	justify-content: flex-end;
}

.clickable {
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
}
